import type { FC, ReactNode, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import type { Document as RichTextDocument } from '@contentful/rich-text-types'
import { BLOCKS } from '@contentful/rich-text-types'

import Typography from '@segment/matcha/components/Typography'
import Divider from '@segment/matcha/components/Divider'

import RichText from '@segment/matcha/recipes/RichText'

const copy = {
  heading: `The big win`,
}

const renderNode = {
  [BLOCKS.PARAGRAPH]: (_: any, children: ReactNode) => <Text variant="pLarge">{children}</Text>,
}

interface TheBigWinProps {
  bigWin?: RichTextDocument
}

const TheBigWin: FC<PropsWithChildren<TheBigWinProps>> = ({ bigWin }) => {
  return (
    <Section>
      <Heading tag="h2" variant="h2">
        {copy.heading}
      </Heading>
      {bigWin && (
        <Row>
          <RichText data={bigWin} options={{ renderNode }} />
        </Row>
      )}
      <Divider />
    </Section>
  )
}

const Section = styled.section``

const Row = styled.div``

const Heading = styled(Typography)`
  margin: 0;
  color: ${({ theme }) => theme.palette.twilio.gray[100]};
`

const Text = styled(Typography)`
  margin-top: 8px;
  color: ${({ theme }) => theme.palette.twilio.gray[100]};
`

export default TheBigWin
